import { render, staticRenderFns } from "./CommercialClaimCreate.vue?vue&type=template&id=7792198a&scoped=true&"
import script from "./CommercialClaimCreate.vue?vue&type=script&lang=js&"
export * from "./CommercialClaimCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7792198a",
  null
  
)

export default component.exports